import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import OpenStreetMap from '../OpenStreetMap/OpenStreetMap';
import infoIcon from '../../../public/SiteIcons/information-button.svg';
import infoIconBlack from '../../../public/SiteIcons/information-button-black.svg';
import s from './PlaceMap.css';

class PlaceMap extends Component {
  static propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
    isMapTouched: PropTypes.bool,
    change: PropTypes.any,
    mapSuccess: PropTypes.string,
    mapWarning: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      center: { lat: Number(props.lat), lng: Number(props.lng) },
      isMapTouched: props.isMapTouched,
      success: false,
    };
    this.handleMarkerDragEnd = this.handleMarkerDragEnd.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lat !== this.props.lat || prevProps.lng !== this.props.lng) {
      this.setState({ center: { lat: Number(this.props.lat), lng: Number(this.props.lng) } });
    }
  }

  handleMarkerDragEnd(center) {
    const { change } = this.props;
    const wasTouched = this.state.isMapTouched;
    this.setState({ center, isMapTouched: true, success: !wasTouched || this.state.success });
    change('ListPlaceStep1', 'lat', center.lat);
    change('ListPlaceStep1', 'lng', center.lng);
    change('ListPlaceStep1', 'isMapTouched', true);
  }

  renderWarning(message) {
    const { isMapTouched, success } = this.state;
    if (!isMapTouched) {
      return <div className={cx(s.alertContainer, s.alertDanger, 'alertDangerRtl')}><img src={infoIcon} className={cx(s.dangerIcon, 'dangerIconRtl')} /><strong><span>{message}</span></strong></div>;
    }
    if (success) {
      return <div className={cx(s.alertContainer, s.alertSuccess, 'alertDangerRtl')}><img src={infoIconBlack} className={cx(s.dangerIcon, 'dangerIconRtl')} /><strong><span>{message}</span></strong></div>;
    }
    return null;
  }

  render() {
    const { center, isMapTouched } = this.state;
    const message = isMapTouched ? this.props.mapSuccess : this.props.mapWarning;
    return <div className={s.positionRelative}>
      <div className={s.positionAbsolute}>{this.renderWarning(message)}</div>
      <div className={s.tabViewMap}>
        <OpenStreetMap center={center} zoom={14} minZoom={5} maxZoom={18} height={554} circleRadius={100} draggableMarker onMapClick={this.handleMarkerDragEnd} onMarkerDragEnd={this.handleMarkerDragEnd} />
      </div>
    </div>;
  }
}

export default withStyles(s)(connect(null, { change })(PlaceMap));
